export class MealCategoryMiniEntity {
    createdAt?: string;
    id?: number;
    name?: string | null;
    iconUrl?: string | null;
    enabled?: boolean;
    order?: number | null;
    isTierFree?: boolean;
    isCompanyFree?: boolean;
    totalItems?: number;
}